/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { array, object } from 'prop-types';
import { Link } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = (theme) => ({
    shipUnableWrapper: {
        display: 'flex',
        width: '85%',
        marginTop: 15,
        padding: '0px 15px',
        '& img': {
            width: 25,
            maxWidth: '100%',
            verticalAlign: 'middle',
        },
        '& a': {
            fontWeight: '400',
            textDecoration: 'underline',
            color: '#000',
        },
        '& .ml-2': {
            marginLeft: '0.5em',
        },
        [theme.breakpoints.down(theme?.breakpoints?.minWidth?.small_screen_down)]: {
            width: '100%',
            '& span': {
                fontSize: '.8125rem',
            },
        },
    },
    imageWrapper: {
        width: 50,
        [theme.breakpoints.down(theme?.breakpoints?.minWidth?.small_screen_down)]: {
            width: 25,
        },
    },
});

const ProductUnableToShip = ({ restrictedStates, classes }) => {
    const truckCancelImg = 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt0594a3795e07975a/63feecea46ea991125804840/truck-cancel.svg';
    if (!restrictedStates?.restricted_state || !restrictedStates.collection_url) return null;
    const isParticularVendorErrorMsg = restrictedStates?.restricted_state.join(', ') || 'CA, TX, AZ';
    return (
        <section className={classes.shipUnableWrapper}>
            <div className={classes.imageWrapper}>
                <img src={truckCancelImg} alt="unable to ship" />
            </div>
            <span className="ml-2">{`We’re unable to ship this item to recipients in ${isParticularVendorErrorMsg}.`} See products available to ship <Link to={`/c${restrictedStates.collection_url}`}>here</Link>.</span>
        </section>
    );
};

ProductUnableToShip.propTypes = {
    restrictedStates: array.isRequired,
    classes: object.isRequired,
};

export default React.memo(withStyles(styles)(ProductUnableToShip));
